module.exports = __webpack_public_path__ + "img/emoji-beers-240x240.66c5cf6d.png";